// The helper name is verbose by design. Every caller must confront the
// semantic requirement that the argument is an EventSlug (not a
// MarketSlug, not a question, not a search term). A
// `polymarketEventUrlFromEventSlug(market.market_slug)` call is a bug;
// the verbose name makes the call site read wrong on review, which is
// the cheapest possible guard. This codebase has had a production-class
// bug from a too-generic `slug` name; verbosity is cheaper than
// ambiguity.

export function polymarketEventUrlFromEventSlug(eventSlug?: string | null) {
  const clean = eventSlug?.trim();
  if (!clean) return '';
  return `https://polymarket.com/event/${encodeURIComponent(clean)}`;
}
